// extracted by mini-css-extract-plugin
module.exports = {"section":"_5dcab43e","noArticles":"_c70751c1","content":"_351113de","article":"_dc165cd3"};